import { styled } from '@mui/material';
import { ProtectedNavLink } from 'components';

export const StyledMoodLink = styled(ProtectedNavLink)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  '&:focus-visible': {
    background: theme.palette.grey[900],
    opacity: 0.3,
  },
}));
